import { STATE_NAME } from './constants';
import { RootState } from './types';

export const getState = (state: RootState) => state[STATE_NAME];
export const getPlayedExperiments = (state: RootState) =>
  getState(state).played;
export const getUserIdentifier = (state: RootState) =>
  getState(state).userIdentifier;
export const getSelectedVariants = (state: RootState) =>
  getState(state).variants;
